import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import type { ReactNode } from "react";

export type InlineTruncateHoverProps = {
  children: ReactNode;
  maxChars?: number; // maximum number of characters before truncation
  className?: string;
};

export function InlineTruncateHover({ children, maxChars = 50, className = "" }: InlineTruncateHoverProps) {
  const text = typeof children === "string" ? children : String(children);
  const shouldTruncate = text.length > maxChars;

  if (!shouldTruncate) {
    return <>{children}</>;
  }

  return (
    <TooltipPrimitive.Provider delayDuration={300}>
      <TooltipPrimitive.Root>
        <TooltipPrimitive.Trigger asChild>
          <span
            tabIndex={0}
            className={`inline cursor-help underline decoration-dotted underline-offset-2 ${className}`}
            style={{ display: "inline" }}
          >
            {text.substring(0, maxChars)}...
          </span>
        </TooltipPrimitive.Trigger>
        <TooltipPrimitive.Portal>
          <TooltipPrimitive.Content
            className="z-50 rounded-lg bg-primary-solid px-3 py-2 text-xs font-semibold text-white shadow-lg"
            sideOffset={6}
          >
            {children}
          </TooltipPrimitive.Content>
        </TooltipPrimitive.Portal>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  );
}
